export default __webpack_public_path__ + "static/media/CNo.65-7.bab81973.jpg";